import React from 'react'
import { Navigate } from 'react-router-dom';

function ProtectedRoute(props) {
  const isLoggedIn = localStorage.getItem('token');

  return isLoggedIn ? props.children : <Navigate to="/login" />
}

export default ProtectedRoute